import { flightsSessionStore } from "@flights/web-api-utils-universal";
const isInternal = process.env.BUILD_TARGET === "client" && !!window?.__GLOBAL_CONTEXT__?.isInternal;
const STORAGE_KEY = "watchClientMetrics";
let enabled = false;
const init = () => {
    enabled = flightsSessionStore.get(STORAGE_KEY) === "1";
};
export const enable = () => {
    if (!isInternal)
        return;
    enabled = true;
    flightsSessionStore.set(STORAGE_KEY, "1");
};
export const disable = () => {
    enabled = false;
    flightsSessionStore.set(STORAGE_KEY, "");
};
export const toggle = () => {
    enabled ? disable() : enable();
};
export const isEnabled = () => enabled;
export const log = (name, value) => {
    if (!enabled)
        return;
    const hasValue = typeof value === "number";
    const color = hasValue ? "purple" : "blue";
    const label = `font-weight: bold; color: ${color}`;
    if (hasValue) {
        console.log(`%c[metric]%c ${name}: %c${value}`, label, "font-weight: normal;", "font-weight: bold");
    }
    else {
        console.log(`%c[metric]%c ${name}`, label, "font-weight: normal;");
    }
};
if (isInternal) {
    init();
}
